import { render } from "./main.vue?vue&type=template&id=563b59d0"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=563b59d0&lang=less"
script.render = render

export default script